// import 'slick-carousel/slick/slick';

// setTimeout(function() { 
//   var numSliders = $('.large-showcase-slider').length + 1;

//   for (let i = 1; i < numSliders; i++) {

//     var slider = $('#large-showcase-slider-' + i);

//     var arrows = $('#arrows-' + i );

//     var dots = $('#dots-' + i );

//     slider.slick({
//       autoplay: false,
//       autoplaySpeed: 2000,
//       arrows: true,
//       dots: true,
//       infinite: true,
//       speed: 500,
//       slidesToShow: 1,
//       slidesToScroll: 1,
//       appendArrows: arrows,
//       appendDots: dots,
//       responsive: [
//         {
//           breakpoint: 1024,
//           settings: {
//             slidesToShow: 1,
//           },
//         }
//       ]
//     });

//     $('#large-showcase-slider-' + i).on('init reInit afterChange', function(event, slick, currentSlide, nextSlide){
      
//       //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
//       console.log('changed');
//       var $counter = $('#counter-'+ i);
//       var c = (currentSlide ? currentSlide : 0) + 1;
//       $counter.text(c+ '/' + slick.slideCount);
//     });
//   }

//   var numSliders = $('.showcase-slider').length + 1;

//   for (let i = 1; i < numSliders; i++) {

//     var slider = $('#showcase-slider-' + i);

//     var arrows = $('#arrows-' + i );

//     var dots = $('#dots-' + i );

//     slider.slick({
//       autoplay: false,
//       autoplaySpeed: 2000,
//       arrows: true,
//       dots: true,
//       infinite: true,
//       speed: 500,
//       slidesToShow: 3,
//       slidesToScroll: 1,
//       appendArrows: arrows,
//       appendDots: dots,
//       responsive: [
//         {
//           breakpoint: 1024,
//           settings: {
//             slidesToShow: 1,
//           },
//         }
//       ]
//     });

    
//   }

 

  
// }, 600);